import { useTimezone } from '@app/core/hooks';
import { DateTimeField, SelectField } from '@mi-front/ui';
import { useFormikContext } from 'formik';
import moment from 'moment';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useStationsWithLowerthird } from '../../../../utils';

export function LowerthirdForm() {
  const { formatMessage } = useIntl();
  const tz = useTimezone();
  const fp = useFormikContext<{ _format: string }>();
  const stations = useStationsWithLowerthird();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        fp.submitForm();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-4">
          <DateTimeField
            name="from"
            dateLabel={formatMessage({
              id: 'common.dateStart',
              defaultMessage: 'Fecha inicio',
            })}
            timeLabel={formatMessage({
              id: 'common.timeStart',
              defaultMessage: 'Hora inicio',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </div>
        <div className="col-4">
          <DateTimeField
            name="to"
            dateLabel={formatMessage({
              id: 'common.dateEnd',
              defaultMessage: 'Fecha fin',
            })}
            timeLabel={formatMessage({
              id: 'common.timeEnd',
              defaultMessage: 'Hora fin',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <SelectField
            isSearchable
            name="station"
            label={formatMessage({
              id: 'audit.gipReport.form.stations',
              defaultMessage: 'Emisoras',
            })}
            placeholder={formatMessage({
              id: 'audit.gipReport.form.allStationsDefault',
              defaultMessage: 'Todas las emisoras',
            })}
            options={stations}
            isClearable
            getOptionValue={(station) => station.slug}
            getOptionLabel={(station) => station.name}
          />
        </div>
      </div>
    </>
  );
}
